import * as Yup from 'yup';
import {
  emailSchema,
  passwordSchema,
  passwordMatchSchema,
  nameSchema,
} from './fieldSchemas';

export const RegisterSchema = Yup.object().shape({
  name: nameSchema({
    required: true,
    requiredMessage: 'Kullanıcı adı zorunlu',
  }),
  email: emailSchema({
    required: true,
    requiredMessage: 'Email zorunlu',
  }),
  password: passwordSchema({
    required: true,
    requiredMessage: 'Şifre zorunlu',
    minLength: 6,
    minLengthMessage: 'Şifre en az 6 karakter olmalı',
  }),
  confirmPassword: passwordMatchSchema('password', {
    required: true,
    requiredMessage: 'Şifre tekrarı zorunlu',
    message: 'Şifreler eşleşmiyor',
  }),
});
